import { Button, IconButton } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import React, { useRef, useEffect, useState } from "react";

const LS_NAME = 'audioMessageRate';

const AudioComponent = ({ url }) => {
    const audioRef = useRef(null);
    const [audioRate, setAudioRate] = useState(parseFloat(localStorage.getItem(LS_NAME) || "1"));
    const [showButtonRate, setShowButtonRate] = useState(false);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.playbackRate = audioRate;
        }
        localStorage.setItem(LS_NAME, audioRate);
    }, [audioRate]);

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.onplaying = () => {
                setShowButtonRate(true);
            };
            audioRef.current.onpause = () => {
                setShowButtonRate(false);
            };
            audioRef.current.onended = () => {
                setShowButtonRate(false);
            };
            audioRef.current.onerror = () => {
                setHasError(true);
            };
        }
    }, [url]);

    const toogleRate = () => {
        let newRate = 1;
        switch (audioRate) {
            case 0.5:
                newRate = 1;
                break;
            case 1:
                newRate = 1.5;
                break;
            case 1.5:
                newRate = 2;
                break;
            case 2:
                newRate = 0.5;
                break;
            default:
                newRate = 1;
                break;
        }
        setAudioRate(newRate);
    };

    return (
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <audio ref={audioRef} controls preload="metadata" style={{ maxWidth: 280, height: 40 }}>
                <source src={url} type="audio/ogg; codecs=opus" />
                <source src={url} type="audio/ogg" />
                <source src={url} type="audio/mpeg" />
                <source src={url} type="audio/mp4" />
                <source src={url} />
                Seu navegador não suporta reprodução direta.
            </audio>
            {showButtonRate && (
                <Button size="small" variant="outlined" style={{ minWidth: 32, padding: "2px 6px", fontSize: "0.75rem" }} onClick={toogleRate}>
                    {audioRate}x
                </Button>
            )}
            {hasError && (
                <IconButton size="small" component="a" href={url} target="_blank" download title="Baixar áudio">
                    <GetAppIcon fontSize="small" />
                </IconButton>
            )}
        </div>
    );
};

export default AudioComponent;